import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FAQ_ITEMS = [
  { q: 'ما هي منصة تسيار؟', a: 'منصة سعودية متكاملة لإدارة الأندية والأكاديميات الرياضية: اللاعبين، الفرق، الحضور، الشؤون المالية، والتواصل في مكان واحد.' },
  { q: 'هل توجد تجربة مجانية؟', a: 'نعم، تجربة مجانية كاملة الميزات لمدة 30 يوماً بدون الحاجة لبطاقة ائتمانية.' },
  { q: 'كيف أسجّل منشأتي؟', a: 'اضغط زر «ابدأ تجربتك المجانية» في أعلى الصفحة وأكمل بيانات منشأتك خلال دقائق.' },
  { q: 'هل تدعم المنصة الأندية والأكاديميات؟', a: 'نعم، تسيار مصممة لتخدم الأندية والأكاديميات الرياضية بكل احتياجاتها الإدارية والمالية.' },
  { q: 'هل بياناتي وبيانات منشأتي بأمان؟', a: 'نعم، تُخزَّن بيانات كل منشأة بشكل معزول تماماً عن المنشآت الأخرى وبمعايير أمان عالية.' },
  { q: 'كيف أتواصل مع فريق الدعم؟', a: 'بعد تسجيل الدخول يمكنك التحدث مع «مساعد تسيار» أو رفع تذكرة دعم من صفحة الدعم داخل حسابك.' },
];

const PublicFaqWidget = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      <div className="fixed bottom-24 left-6 z-50 lg:bottom-6">
        <button
          onClick={() => setIsOpen(!isOpen)}
          data-testid="public-faq-widget-toggle-btn"
          className={`relative w-14 h-14 rounded-full shadow-xl transition-transform duration-200 hover:scale-105 active:scale-95 overflow-hidden
            ${isOpen ? 'bg-gradient-to-br from-slate-600 to-slate-700' : 'bg-[#0A192F]'} border-2 border-white/30`}
          title={isOpen ? 'إغلاق الأسئلة الشائعة' : 'أسئلة شائعة'}
        >
          <div className="absolute inset-0 flex items-center justify-center">
            {isOpen ? (
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            ) : (
              <img src="/club-logo-192.png?v=20260915b" alt="أسئلة شائعة" className="w-full h-full object-cover" />
            )}
          </div>
        </button>
      </div>

      {isOpen && (
        <div dir="rtl" className="fixed bottom-[168px] left-6 w-[calc(100vw-3rem)] max-w-[380px] h-[540px] bg-white rounded-3xl shadow-2xl border border-slate-200 z-40 flex flex-col overflow-hidden lg:bottom-24" data-testid="public-faq-widget-window">
          <div className="bg-[#0A192F] p-4 text-white">
            <div className="flex items-center gap-2.5">
              <img src="/club-logo-192.png?v=20260915b" alt="" className="h-9 w-9 rounded-xl shrink-0" />
              <div className="min-w-0">
                <h3 className="font-bold text-base">أسئلة شائعة عن تسيار</h3>
                <p className="text-white/60 text-[11px] truncate">سجّل دخولك للوصول إلى مساعد تسيار الذكي</p>
              </div>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-3 space-y-2 bg-slate-50" data-testid="public-faq-list">
            {FAQ_ITEMS.map((item, i) => (
              <div key={i} className="rounded-2xl border border-slate-200 bg-white overflow-hidden" data-testid={`public-faq-item-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-2 px-4 py-3 text-right"
                  data-testid={`public-faq-question-${i}`}
                >
                  <span className="text-sm font-bold text-slate-800">{item.q}</span>
                  <svg className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                </button>
                {openIndex === i && (
                  <p className="px-4 pb-3 text-[13px] leading-relaxed text-slate-500" data-testid={`public-faq-answer-${i}`}>{item.a}</p>
                )}
              </div>
            ))}
          </div>

          <div className="border-t border-slate-100 bg-white p-3">
            <button
              type="button"
              onClick={() => { setIsOpen(false); navigate('/register'); }}
              data-testid="public-faq-register-btn"
              className="w-full rounded-xl bg-teal-600 py-2.5 text-sm font-bold text-white transition-colors hover:bg-teal-700"
            >
              ابدأ تجربتك المجانية الآن
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PublicFaqWidget;
